<template>
  <v-navigation-drawer v-model="drawerModel" width="270">
    <v-container height="100%" class="d-flex flex-column justify-space-between">
      <div>
        <v-sheet class="mb-10">
          <v-btn
            v-if="!$store.state.isMobile"
            height="48"
            size="small"
            block
            rounded="xl"
            color="#2CA6F7"
            class="mb-4 text-body-2"
            @click="newMail()"
            style="font-family: 'SF UI Display', sans-serif; font-size: 14px"
          >
            Написать
            <v-icon class="ml-3">
              <svg
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 16H3.9L13.7 6.225L12.975 5.5L12.275 4.8L2.5 14.6V16ZM1.5 18C1.21667 18 0.979003 17.904 0.787003 17.712C0.595003 17.52 0.499337 17.2827 0.500003 17V14.575C0.500003 14.3083 0.550004 14.054 0.650004 13.812C0.750004 13.57 0.89167 13.3577 1.075 13.175L13.7 0.575C13.8833 0.391667 14.1 0.25 14.35 0.15C14.6 0.0500001 14.8583 0 15.125 0C15.3917 0 15.6457 0.0500001 15.887 0.15C16.1283 0.25 16.3493 0.4 16.55 0.6L17.925 2C18.125 2.18333 18.2707 2.396 18.362 2.638C18.4533 2.88 18.4993 3.134 18.5 3.4C18.5 3.65 18.454 3.9 18.362 4.15C18.27 4.4 18.1243 4.625 17.925 4.825L5.325 17.425C5.14167 17.6083 4.929 17.75 4.687 17.85C4.445 17.95 4.191 18 3.925 18H1.5ZM13.7 6.225L12.975 5.5L12.275 4.8L13.7 6.225Z"
                  fill="white"
                />
              </svg>
            </v-icon>
          </v-btn>
          <v-list density="compact" nav color="#10A6F2">
            <v-list-item
              rounded="xl"
              nav
              :value="mailItem"
              v-for="mailItem in $store.state.mailbox"
              :key="mailItem.title"
              @click="handleItemClick(mailItem)"
              :active="isCurrentMailbox(mailItem)"
              :disabled="isCurrentMailbox(mailItem) && isProcessing"
            >
              <template v-slot:prepend>
                <v-icon class="mr-2" icon="mdi-gmail" size="40px"> </v-icon>
                {{ mailItem.title }}
              </template>
            </v-list-item>
          </v-list>
        </v-sheet>

        <v-sheet
          border
          rounded="lg"
          class="pa-1"
          :color="$vuetify.theme.current.dark ? '#212121' : '#F7F7F9'"
          v-if="this.$store.state.selectNav.length > 0"
        >
          <v-list density="compact" nav color="#10A6F2" @click="closeModal">
            <v-list-item-subtitle style="font-size: 14px; color: #8e8e93">
              Папки
            </v-list-item-subtitle>
            <v-list-item
              rounded="xl"
              nav
              v-for="(folder, index) in this.$store.state.selectNav[0].folders"
              :key="folder.title"
              :class="{ 'active-item': isActive(folder.id) }"
              @click="handleFolderClick(folder)"
            >
              <v-list-item-title style="font-size: 16px">
                {{ folder.title }}
              </v-list-item-title>
              <template v-slot:prepend>
                <v-icon>
                  <div
                    v-html="folder.icon"
                    :class="{ 'active-icon': isActive(folder.id) }"
                  ></div>
                </v-icon>
              </template>
              <template
                v-if="
                  index == 0 &&
                  Object.values(folder.items).reduce((acc, category) => {
                    return (
                      acc +
                      category.mails.filter(
                        (mails) => mails.flag.isSeen === false
                      ).length
                    );
                  }, 0) > 0
                "
                v-slot:append
              >
                <v-chip color="#10A6F2">
                  {{
                    Object.values(folder.items).reduce((acc, category) => {
                      return (
                        acc +
                        category.mails.filter(
                          (mails) => mails.flag.isSeen === false
                        ).length
                      );
                    }, 0)
                  }}
                </v-chip>
              </template>
            </v-list-item>
          </v-list>
        </v-sheet>
      </div>

      <v-list-item nav value="settings" @click="setIsSetting" rounded="xl">
        <v-list-item-title> Настройки </v-list-item-title>
        <template v-slot:prepend>
          <svg
            class="mr-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_293_1271)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.414 2.10056C12.633 1.31951 11.3667 1.31951 10.5856 2.10056L8.68609 4.00005H5.99978C4.89521 4.00005 3.99978 4.89548 3.99978 6.00005V8.68636L2.10032 10.5858C1.31927 11.3669 1.31927 12.6332 2.10031 13.4143L3.99978 15.3137V18.0001C3.99978 19.1046 4.89521 20.0001 5.99978 20.0001H8.68609L10.5856 21.8995C11.3667 22.6806 12.633 22.6806 13.414 21.8995L15.3135 20.0001H17.9998C19.1044 20.0001 19.9998 19.1046 19.9998 18.0001V15.3138L21.8993 13.4143C22.6804 12.6332 22.6804 11.3669 21.8993 10.5858L19.9998 8.68632V6.00005C19.9998 4.89548 19.1044 4.00005 17.9998 4.00005H15.3135L13.414 2.10056ZM11.9998 3.51477L13.8993 5.41426C14.2744 5.78934 14.7831 6.00005 15.3135 6.00005H17.9998V8.68632C17.9998 9.21676 18.2105 9.72547 18.5856 10.1005L20.4851 12.0001L18.5856 13.8996C18.2105 14.2746 17.9998 14.7833 17.9998 15.3138V18.0001H15.3135C14.7831 18.0001 14.2744 18.2108 13.8993 18.5858L11.9998 20.4853L10.1003 18.5858C9.72523 18.2108 9.21653 18.0001 8.68609 18.0001H5.99978V15.3137C5.99978 14.7833 5.78907 14.2746 5.41399 13.8995L3.51452 12.0001L5.41399 10.1006C5.78907 9.7255 5.99978 9.2168 5.99978 8.68636V6.00005H8.68609C9.21652 6.00005 9.72523 5.78934 10.1003 5.41426L11.9998 3.51477ZM9.99981 12C9.99981 10.8954 10.8953 10 11.9998 10C13.1044 10 13.9998 10.8954 13.9998 12C13.9998 13.1046 13.1044 14 11.9998 14C10.8953 14 9.99981 13.1046 9.99981 12ZM11.9998 8C9.79067 8 7.99981 9.79086 7.99981 12C7.99981 14.2091 9.79067 16 11.9998 16C14.209 16 15.9998 14.2091 15.9998 12C15.9998 9.79086 14.209 8 11.9998 8Z"
                fill="#10A6F2"
              />
            </g>
            <defs>
              <clipPath id="clip0_293_1271">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </template>
      </v-list-item>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import axios from "axios";

export default {
  name: "Main-component",
  components: {},
  props: {
    newMail: Function,
    drawer: Boolean,
    setDrawer: Function,
    setIsSetting: Function,
    closeMail: Function,
    item: Object,
    closeModal: Function,
  },

  data() {
    return {
      isNewMail: false,
      fwd: false,
      sendModal: false,
      isSearchMenu: false,
      isModal: false,
      isProcessing: false,
      loadingCount: 0,
      updateInterval: null,
    };
  },

  methods: {
    async handleItemClick(mailItem) {
      if (this.isProcessing) return;

      if (this.isCurrentMailbox(mailItem)) {
        return;
      }

      this.isProcessing = true;

      try {
        this.$store.commit("setSelectNav", [mailItem]);
        this.$store.commit(
          "setIndex",
          this.$store.state.mailbox.indexOf(mailItem)
        );

        await this.changeBox();

        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            mailbox: mailItem.title,
            folder: this.$store.state.selectNav[0]?.folders?.[0]?.id || null,
          },
        });
        this.isModal = false;
      } finally {
        this.isProcessing = false;
      }
    },

    async handleFolderClick(folder) {
      if (this.isProcessing) return;

      if (this.isActive(folder.id) && !this.item.body) {
        return;
      }

      this.isProcessing = true;

      try {
        this.$router.push({
          path: "/",
          query: {
            ...this.$route.query,
            folder: folder.id,
          },
        });
        this.closeMail();
      } finally {
        this.isProcessing = false;
      }
    },

    async changeBox() {
      try {
        this.$store.state.selectNav[0].folders = [];

        let formData = new FormData();
        formData.set(`params`, "getUserFolders");
        formData.append(`login`, this.$store.state.selectNav[0].title);
        formData.append(`password`, this.$store.state.selectNav[0].pass);
        formData.append(
          `host`,
          this.$store.state.selectNav[0].type == "imap"
            ? this.$store.state.settings[this.$store.state.selectNav[0].server]
                .imap.address
            : this.$store.state.settings[this.$store.state.selectNav[0].server]
                .host
        );
        formData.append(`type`, this.$store.state.selectNav[0].type);
        formData.append(
          `port`,
          this.$store.state.settings[this.$store.state.selectNav[0].server].imap
            .port
        );
        formData.append(`encrypt`, "ssl");
        const folders = await axios.post(
          "https://email.rcgit.ru/imap/",
          formData
        );
        let foldersLocal = [];
        for (const folder of folders.data) {
          foldersLocal.push({
            id: folder.id,
            title: folder.name,
            icon: folder.icon,
            items: [],
          });
        }
        this.$store.state.selectNav[0].folders = foldersLocal;

        if (foldersLocal.length > 0) {
          this.$store.state.selectFolder = [foldersLocal[0]];
          this.$store.commit("setActiveFolder", foldersLocal[0].id);
        }
      } catch (error) {
        console.log({ error });
        if (this.$store.state.selectNav[0].server == "Mailru") {
          await this.refreshWithMailRu();
          await this.changeBox();
        }
      }
    },

    deleteSetting(mailBox) {
      this.isModal = false;
      this.$store.commit("setSelectNav", [mailBox]);
      this.changeBox();
    },

    isCurrentMailbox(mailItem) {
      return (
        this.$store.state.selectNav[0] &&
        this.$store.state.selectNav[0].title === mailItem.title
      );
    },

    isActive(folderId) {
      return this.$store.state.activeFolder == folderId;
    },

    setActive(folderId) {
      this.$store.commit("setActiveFolder", folderId);
    },

    async updateSelectionFromRoute() {
      const { mailbox: mailboxParam, folder: folderParam } = this.$route.query;

      const mailbox = this.$store.state.mailbox.find(
        (i) => i.title === mailboxParam
      );

      if (mailbox) {
        if (!this.isCurrentMailbox(mailbox)) {
          await this.$store.commit(
            "setIndex",
            this.$store.state.mailbox.indexOf(mailbox)
          );
          await this.$store.commit("setSelectNav", [mailbox]);

          if (
            !this.$store.state.selectNav[0].folders ||
            this.$store.state.selectNav[0].folders.length === 0
          ) {
            await this.changeBox();
          }
        }

        let folderToActivate = null;

        if (folderParam) {
          folderToActivate = this.$store.state.selectNav[0].folders.find(
            (f) => String(f.id) === String(folderParam)
          );
        }

        if (
          !folderToActivate &&
          this.$store.state.selectNav[0].folders.length > 0
        ) {
          folderToActivate = this.$store.state.selectNav[0].folders[0];

          if (!folderParam) {
            await this.$router.replace({
              path: this.$route.path,
              query: {
                ...this.$route.query,
                folder: folderToActivate.id,
              },
            });
            return;
          }
        }

        if (folderToActivate && !this.isActive(folderToActivate.id)) {
          await this.$store.commit("setActiveFolder", folderToActivate.id);
          await this.$store.commit("setSelectFolder", [folderToActivate]);
        }
      } else {
        const defaultMailbox = this.$store.state.mailbox[0];
        if (defaultMailbox) {
          const query = { mailbox: defaultMailbox.title };

          await this.$store.commit(
            "setIndex",
            this.$store.state.mailbox.indexOf(defaultMailbox)
          );
          await this.$store.commit("setSelectNav", [defaultMailbox]);

          if (
            !this.$store.state.selectNav[0].folders ||
            this.$store.state.selectNav[0].folders.length === 0
          ) {
            await this.changeBox();
          }

          if (this.$store.state.selectNav[0].folders?.length > 0) {
            query.folder = this.$store.state.selectNav[0].folders[0].id;
          }

          await this.$router.replace({
            path: this.$route.path,
            query,
          });
        }
      }
    },
  },

  watch: {
    "$route.query": {
      handler() {
        this.updateSelectionFromRoute();
      },
      immediate: false,
    },
  },

  computed: {
    drawerModel: {
      get() {
        return this.drawer;
      },
      set(value) {
        this.setDrawer(value);
      },
    },
  },

  async mounted() {
    if (!this.$route.query.mailbox && !this.$route.query.folder) {
      const defaultMailbox = this.$store.state.mailbox[0];
      if (defaultMailbox) {
        await this.$store.commit(
          "setIndex",
          this.$store.state.mailbox.indexOf(defaultMailbox)
        );
        await this.$store.commit("setSelectNav", [defaultMailbox]);

        if (
          !this.$store.state.selectNav[0].folders ||
          this.$store.state.selectNav[0].folders.length === 0
        ) {
          await this.changeBox();
        }

        const query = { mailbox: defaultMailbox.title };

        if (this.$store.state.selectNav[0].folders?.length > 0) {
          query.folder = this.$store.state.selectNav[0].folders[0].id;
        }

        await this.$router.replace({
          path: this.$route.path,
          query,
        });
      }
    } else {
      await this.updateSelectionFromRoute();
    }
  },

  beforeUnmount() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  },
};
</script>
